export default __webpack_public_path__ + "static/media/IMG_2326.28822ba1.JPG";